import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListFirstNameCell } from '@app/feature/user/user-list/user-list-first-name.cell';
import { UserListFirstNameHeader } from '@app/feature/user/user-list/user-list-first-name.header';

export const CustomerUserListFirstNameColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['firstName']
> = {
  enableSorting: false,
  header: UserListFirstNameHeader,
  cell: UserListFirstNameCell,
};
